<div class="flex">
  <p>
    Built with <a href="https://svelte.dev/">Svelte</a> by
    <a href="https://toluagboola.github.io/"
      ><strong>Toluwanimi Isaiah</strong></a
    >
  </p>

  <div>
    <ul>
      <li><a href="https://github.com/toluagboola/feedbackify">GitHub</a></li>
    </ul>
  </div>
</div>

<style>
  .flex {
    display: flex;
    padding-top: 40px;
    justify-content: space-between;
  }

  a {
    color: #fff;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
</style>
